import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bannerImage from '../assets/img/banner_ikimo.jpg'; // Ajusta la ruta según sea necesario

const Salir = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');

  const handleContinue = () => {
    setShowForm(true);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Lógica para manejar el envío del formulario
    console.log('Email:', email);
    console.log('Reason:', reason);
    // Mostrar mensaje de agradecimiento
    setShowThankYou(true);
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {!showForm && !showThankYou && (
          <>
            <h1>¡Es una pena que no nos acompañes hasta el final de esta RUTA AL ÉXITO!</h1>
            <p>
              Teníamos más para presentarte. Si siempre deseas SALIR dale “continuar” y si aún deseas
              permanecer en la RUTA puedes darle a “regresar”.
            </p>
            <div style={styles.buttonContainer}>
              <button style={styles.button} onClick={handleBack}>Regresar</button>
              <button style={styles.button} onClick={handleContinue}>Continuar</button>
            </div>
          </>
        )}
        {showForm && !showThankYou && (
          <form onSubmit={handleSubmit}>
            <h1>Tu opinión nos importa mucho</h1>
            <p>
              ¿Podrías decirnos cuál es la razón por la cual decidiste SALIR?
              Solo por responder te enviaremos un BEST SELLER de superación personal a tu correo.
              MUCHÍSIMAS GRACIAS.
            </p>
            <div style={styles.formGroup}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Correo electrónico"
                style={styles.input}
              />
            </div>
            <div style={styles.formGroup}>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows="3"
                required
                placeholder="¿Por qué no deseas continuar?"
                style={styles.textarea}
              />
            </div>
            <button type="submit" style={styles.button}>Enviar</button>
          </form>
        )}
        {showThankYou && (
          <div>
            <h1>¡Muchas gracias!</h1>
            <p>Revisa tu correo electrónico.</p>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    padding: '20px',
    color: '#fff', // Ajusta el color del texto para que sea legible sobre la imagen de fondo
  },
  content: {
    textAlign: 'center',
    maxWidth: '800px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px', // Espacio entre los botones
    marginTop: '20px',
  },
  button: {
    padding: '15px 30px', // Aumenta el tamaño del botón
    fontSize: '18px', // Aumenta el tamaño del texto
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    transition: 'background-color 0.3s, color 0.3s',
  },
  buttonHover: {
    backgroundColor: '#000',
    color: '#fff',
  },
  formGroup: {
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  textarea: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
};

export default Salir;